module.exports = __webpack_public_path__ + "static/img/8.68867b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/zh/8.png
// module id = 0iJQ
// module chunks = 0